<template>
    <div class="landings-page container-fluid">

        <!-- Hero -->
        <div class="hero align-items-center ">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 p-0">
                <img src="../../assets/Landingspage_Header.svg" />
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 text-center ">
                <img src="../../../src/assets/Logo_RayiQ.svg" height="87" class="d-inline mt-md-5" />
                <div>
                    <h1 class="">{{ $t('landingspage.KeepTrackTitle') }}</h1>
                </div>

                <p class="intro">{{ $t('landingspage.intro') }}</p>
                <div>
                    <div class="button-border button-border--animated">
                        <a href="#HowToGetStarted" class="">{{ $t('landingspage.HowToGetStarted') }}</a>
                    </div>
                    <!--<router-link v-if="$store.state.isLoggedIn == true" :to="{ name: 'DashboardHome' }" class="blue-gradient">To dashboard</router-link>
        <router-link v-else :to="{ name: 'Login' }" class="blue-gradient">Log in</router-link>-->
                </div>
            </div>
        </div>

        <!-- DEMO VIDEO -->
        <div class="video blue-gradient">
            <div class="col-12">


                <div class="row text-center">
                    <div class="col-12">
                        <h2 class="color-white">{{ $t('landingspage.rayiqExplained') }}</h2>
                    </div>
                </div>

                <div class="video_wrapper-outer">
                    <div class="video_wrapper">
                        <div class="video_container">
                            <iframe src="https://www.youtube-nocookie.com/embed/ZqzMmozOyUg" title="YouTube video player" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Features -->
        <div class="features text-center">

            <div class="features_title">
                <h2>{{ $t('landingspage.packedWithFeatures') }}</h2>
            </div>

            <div class="features_wrapper" id="features">

                <landingspage-feature 
                                      backgroundColorClass="blue-gradient"
                                      iconColorClass="color-blue"
                                      icon="box-arrow-in-right"
                                      :title=" $t('landingspage.easyImport') "
                                      :text="$t('landingspage.easyImportText') ">
                </landingspage-feature>

                <landingspage-feature backgroundColorClass="purple-gradient"
                                      iconColorClass="color-graph-purple"
                                      icon="clipboard-check"
                                      :title=" $t('landingspage.easyReporting')"
                                      :text="$t('landingspage.easyReportingText')">
                </landingspage-feature>


                <landingspage-feature backgroundColorClass="red-gradient"
                                      iconColorClass="color-red "
                                      icon="clock"
                                      :title="$t('landingspage.automaticReminders')"
                                      :text="$t('landingspage.automataticRemindersText')">
                </landingspage-feature>

                <landingspage-feature backgroundColorClass="yellow-gradient"
                                      iconColorClass="color-yellow"
                                      icon="tools"
                                      :title=" $t('landingspage.apronConfigurator') "
                                      :text="$t('landingspage.apronConfiguratorText') ">
                </landingspage-feature>

                <landingspage-feature backgroundColorClass="green-gradient"
                                      iconColorClass="color-green"
                                      icon="list-check"
                                      :title="$t('landingspage.upToDateInventory')"
                                      :text="$t('landingspage.upToDateInventoryText') ">
                </landingspage-feature>




            </div>
        </div>

        <!-- CTA Configurator -->
        <!--<div class="row bg-white text-center pt-5">
            <div class="col-12">
                <h1>Configure your next Scanflex lead apron</h1>
            </div>
        </div>

        <div class="row bg-white text-center pb-5 pt-5 justify-content-center">
            <div class="col-12 col-md-8 col-lg-6 ">
                <div class="bg-configurator"></div>
                <router-link :to="{ name: 'ProductSelector', params: { category: 2 } }" class="medium-button blue-gradient align-bottom">Start Configurator</router-link>
            </div>
        </div>-->
        <!-- Questions -->
        <!--<div class="row h-100 blue-gradient pb-5 pt-5 justify-content-md-between justify-content-lg-center">
            <div class="col-12 col-md-5 col-lg-6 my-auto text-center">
                <h1 class="color-white align-middle mb-4 mb-lg-0">Frequently Asked Questions</h1>
            </div>
            <div class="col-12 col-md-6 col-lg-4 ">
                <div class="bg-white shadow rounded  p-3 p-lg-5">
                    <h2>How can I start using Ray iQ?</h2>
                    <p class="m-0">Currently Ray iQ is in a private beta stage and is accessible by invitation only. In the near future, Ray iQ will become accessible to all Cablon Medical customers with exclusive agreements for the purchase of Scanflex lead aprons and accessories. </p>
                </div>
                <div class="bg-white shadow rounded p-3 p-lg-5 mt-5">
                    <h2>Will I have to manually fill the database with our inventory?</h2>
                    <p class="m-0">Your inventory of Scanflex lead aprons and thyroid collars, purchased through Cablon Medical after June 2011, will automatically be imported to Ray iQ after setting up your account! </p>
                </div>
            </div>
        </div>-->
        <!-- How to get started -->
        <div class="get-started intro text-center bg-light-blue" id="HowToGetStarted">

            <div class="get-started_img">
                <img src="../../assets/Ray-iQ-High_on_laptop.jpg" />
            </div>

            <div class="get-started_cta-wrapper">
                <div class="get-started_text">
                    <h2 class="mb-3">{{ $t('landingspage.HowToGetStarted') }}</h2>
                    <p>{{ $t('landingspage.rayiqAvailabilityMessage') }}</p>
                </div>

                <div class="get-started_buttons">
                    <a href="tel:+31334943964" class="medium-button blue-gradient mr-4 mt-4"><b-icon-telephone-fill /> {{ $t('landingspage.call') }}</a>
                    <a href="mailto:sales@cablon.nl" class="medium-button blue-gradient mr-4 mt-4"><b-icon-envelope-fill /> {{ $t('landingspage.mail') }}</a>

                    <div class="button-border d-inline-block mt-4">
                        <router-link :to="{ name: 'ProductSelector_p', params: { category: 2 } }" target='_blank' class="button-open">{{ $t('landingspage.tryConfigurator') }}</router-link>
                        <!--<a href="https://ray-iq.com/Configurator/ProductSelector/2" target='_blank' class="button-open">Try configurator for free</a>-->
                    </div>
                </div>
            </div>
        </div>

        <!-- Testimonials -->
        <Testimonial></Testimonial>

        <!-- Contact details -->
        <div class="contact-details bg-light-blue" id="ContactDetails">

            <div class="contact-details_wrapper">
                <div class="contact-details_inner">

                    <div class="contact-details_box ">

                        <h3> {{ $t('contact.contactUs') }}</h3>

                        <p class="">{{ $t('contact.suggestionsAndIssues') }}</p>

                        <ul class="list-unstyled mt-2 color-blue">
                            <li><a href="mailto:info@ray-iq.com" class="color-blue small-button "><b-icon-envelope-fill class="mr-2" />   info@ray-iq.com </a></li>
                            <li><a href="tel:+31334943964" class="color-blue small-button mt-2 "><b-icon-telephone-fill class="mr-2" /> +31 33 494 3964 </a></li>
                        </ul>

                    </div>

                    <div class="contact-details_box ">
                        <h3> {{ $t('contact.salesAndLogistics') }}</h3>

                        <p v-html="$t('contact.salesRelatedQuestions')"></p>

                        <ul class="list-unstyled mt-2 color-blue">
                            <li><a href="mailto:sales@cablon.nl" class="color-blue small-button "><b-icon-envelope-fill class="mr-2" /> sales@cablon.nl</a></li>
                            <li><a href="tel:+31334943964" class="color-blue small-button mt-2 "><b-icon-telephone-fill class="mr-2" /> +31 33 494 3964</a></li>
                        </ul>

                    </div>


                    <div class="contact-details_box">
                        <h3> {{ $t('contact.ourLocation') }}</h3>

                        <ul class="list-unstyled mt-2 ">
                            <li class="mt-3">Cablon Medical B.V.</li>
                            <li>Klepelhoek 11</li>
                            <li>3833 GZ</li>
                            <li>Leusden</li>
                            <li>{{ $t('contact.theNetherlands') }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import Testimonial from '@/private/components/Testimonial.vue';
    import LandingspageFeature from '@/private/components/UI-elements/LandingspageFeature.vue';

    export default {

        name: 'Home',
        components: {
            Testimonial,
            LandingspageFeature
        },
        props: {

        },
        data: function () {

            return {

            }

        },
        mounted:function() {
            window.addEventListener('scroll', this.playFeatureAnimations, {passive: true});
        },
        destroyed: function () {
            window.removeEventListener('scroll', this.playFeatureAnimations, { passive: true });
        },
        methods: {
            playFeatureAnimations: function () {
                const el = document.getElementById('features').getBoundingClientRect().top;
                if (el < window.innerHeight - 100) {
   
                    const featureBoxes = document.querySelectorAll('.features_box')
                    for (var i = 0; i < featureBoxes.length; i++) {
                        featureBoxes[i].classList.add('features_animation')
                        featureBoxes[i].style['animation-delay'] = i/4 + 's';
                    }
                }
            }
        }



    }

</script>